// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3IVhL","upload":"Small_upload__1k-u6","imageWrap":"Small_imageWrap__72rXq","removeBtn":"Small_removeBtn__3uztc"};